import React from "react";
import { Route } from "react-router-dom";
import { RouteConfig } from "./routesConfig";
import PrivateRoute from "./PrivateRoute";

export const renderRoutes = (routes: RouteConfig[]) => {
  return routes.map((route) => {
    const { path, element, roles, children } = route;
    return (
      <Route key={path} path={path} element={<PrivateRoute roles={roles}> {element} </PrivateRoute>}>
        {children && renderRoutes(children)}
      </Route>
    );
  });
};
